import { render, staticRenderFns } from "./StatsRdvs.vue?vue&type=template&id=7f641e90&"
import script from "./StatsRdvs.vue?vue&type=script&lang=js&"
export * from "./StatsRdvs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports